import { useEffect, useRef, useCallback } from 'react';

type EffectHandlerT = (arg1: boolean) => void;

/*
 * Invokes the effect handler only when the following indicator was changed as a result of a user click.
 * The effect handler will not be called if the following indicator changed without a user click.
 */
export const useFollowUnfollowEffect = (
  isFollowing: boolean,
  effectHandler?: EffectHandlerT,
) => {
  const clickedRef = useRef<boolean>(false);

  useEffect(() => {
    if (clickedRef.current) {
      effectHandler?.(isFollowing);
    }
  }, [isFollowing, effectHandler]);

  useEffect(() => {
    clickedRef.current = false;
  }, [isFollowing]);

  const handleFollowClick = useCallback(() => {
    clickedRef.current = true;
  }, []);

  return handleFollowClick;
};
